import styled, { css } from "styled-components";

interface FormStyleProps {
  $nav?: boolean;
  $backBtn?: boolean;
  $submitBtn?: boolean;
  $isFindingAccount?: boolean;
}

export const Form = styled.form<FormStyleProps>`
  gap: 30px;
  width: 100%;
  display: grid;
  padding: 16px;
  overflow: auto;
  min-height: ${(props) =>
    props.$nav === false ? "calc(100vh - 56px)" : "calc(100vh - 126px)"};

  ${(props) =>
    props.$submitBtn === true &&
    css`
      grid-template-rows: auto 56px;
    `}
`;

export const FormTitleBox = styled.div<FormStyleProps>`
  gap: 20px;
  display: flex;
  padding: ${(props) => (props.$isFindingAccount ? "0" : "0 10px")};
  flex-direction: column;
`;

export const FormContent = styled.div`
  gap: 40px;
  display: flex;
  flex-direction: column;
`;

export const FormContentInit = styled.div`
  gap: 32px;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const FormBtnBox = styled.div<FormStyleProps>`
  gap: 10px;
  display: grid;

  ${(props) =>
    props.$backBtn === true &&
    css`
      grid-template-columns: 110px auto;
    `}
`;
